import {
    AssistantChatResult,
    AssistantCommandResult,
    AssistantPromptResultBase,
    AssistantPromptResultType,
    AssistantSearchResult,
    useRepositoryQuery,
} from '@mews-commander/data-access';
import { useLanguageCode } from '@mews-commander/core';
import { getCurrentEnterpriseChainId } from '@mews-commander/legacy-entities/src/selectors/session/enterprise';
import { useCommanderSelector } from '@mews-commander/utils';
import { removeMqlTriggerCharacter } from '../searchBar/MqlHelper';

export const useAssistantSearchQuery = (searchTerm: string, enterpriseIds: Array<string>) => {
    const chainId = useCommanderSelector<string>(getCurrentEnterpriseChainId);
    const languageCode = useLanguageCode();
    const trimmedSearchTerm = removeMqlTriggerCharacter(searchTerm?.trimEnd());
    return useRepositoryQuery(
        'assistantChat',
        'prompt',
        {
            searchToken: trimmedSearchTerm ?? '',
            chainId,
            enterpriseIds,
            languageCode,
        },
        {
            enabled: trimmedSearchTerm !== '' && enterpriseIds?.length > 0,
            select: (data) => transformAssistantSearchResult(data),
            staleTime: 3000,
        }
    );
};

export const transformAssistantSearchResult = (result: AssistantPromptResultBase): AssistantResult => {
    const assistantResult: AssistantResult = {
        searchResult: null,
        chatResult: null,
        commandResult: null,
    };

    switch (result?.resultType) {
        case AssistantPromptResultType.SearchResult:
            assistantResult.searchResult = result as AssistantSearchResult;
            break;

        case AssistantPromptResultType.ChatResult:
            assistantResult.chatResult = result as AssistantChatResult;
            break;

        case AssistantPromptResultType.CommandResult:
            assistantResult.commandResult = result as AssistantCommandResult;
            break;
    }

    return assistantResult;
};

export interface AssistantResult {
    searchResult: AssistantSearchResult | null;
    chatResult: AssistantChatResult | null;
    commandResult: AssistantCommandResult | null;
}
